<div class="quick-link-container" [class.no-header]="isStockType">
    <por-app-loader></por-app-loader>
    <ng-container *ngIf="!isStockType">
        <por-header [config]="config" (logout)="logoutUser()" [isLoginButtonVisible]="isLoginButtonVisible"></por-header>
    </ng-container>
    @if (quickLinkData$ | async; as quickLinkData) { @switch (quickLinkData.Type) { @case ('Stock') {
    <ng-container [ngTemplateOutlet]="productDetailTemplate"></ng-container>
    } @case ('Contract') {
    <ng-container [ngTemplateOutlet]="contractDetailTemplate"></ng-container>
    } } } @if (invalidRequest) {
    <div class="align-center">
        <p>{{ 'QuickLinkError' | translate }}</p>
    </div>
    }
</div>

<ng-template #contractDetailTemplate>
    @if (customer$ | async | count) { @if (contractDetail$ | async; as data) { @if (isDetailPageOpened) {
    <div>
        <por-contract-detail
            [contractDetail]="data"
            [uiUrl]="inputs?.uiUrl"
            [customerId]="customerId ?? ''"
            (returnToLogin)="returnToLogin()"
            (loginButtonVisibilityChange)="loginButtonVisibilityChange($event)"></por-contract-detail>
    </div>
    } } }
</ng-template>
<ng-template #productDetailTemplate>
    <ng-container>
        <div class="product-detail">
            @if ((appFacadeService.getProductDetail() | async)?.productDetail) { @if (isDetailPageOpened) {
            <por-product-detail [uiUrl]="inputs?.uiUrl" [isPublicView]="isStockType" (closePanel)="this.appFacadeService.resetProductDetail()" />
            } }
        </div>
    </ng-container>
</ng-template>
